import React from 'react';
import { get, map } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { epostInsuranceInformationPreloader, InsuranceDrugPreferenceForm, InsuranceInformation } from 'ui/views/widgets/epostInsuranceInformation';
import { insuranceBasicInformationForm as InsuranceBasicInformationForm } from 'ui/views/widgets/insuranceBasicInformationForm';
import { MemberCommunicationSettings } from 'ui/containers/MemberCommunicationSettings';
import { memberAddEditAddresspreloader as MemberAddEditAddresspreloader } from 'ui/views/widgets/memberAddEditAddress';
import { MemberAddEditAddress } from 'ui/containers/MemberAddEditAddress';
import { button as Button } from 'modules/button';
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { MemberAddEditBillingAddress } from 'ui/containers/MemberAddEditBillingAddress';
import { coverageSelectionValue, eligibleCoverageOptions, findEligibleCoverage } from 'utils/epostCoverageSelection';


// success view
export const reactivateEpostInsuranceInformationStepSuccess = ( props ) => {
   
    const { isFetchingAddress, isFetchingCommunicationList } = props;
    const isDrug = props.visibility.drugPreferenceAction
    const isBilling = props.visibility.addBillingAddressAction
    const eligibleCoverages = get( props, 'insurance.eligibleCoverages', [] ) || [];
    const currentCoverage = get( props, 'insurance.currentInsurance', {} ) || {};
    const selectedCoverage = findEligibleCoverage( eligibleCoverages, coverageSelectionValue( currentCoverage ) ) || {};
    const coverageOptions = eligibleCoverageOptions( eligibleCoverages );
    const selectedCoverageValue = selectedCoverage.carrier
        ? coverageSelectionValue( selectedCoverage )
        : '';

    return (
        <div className='ui-reactivate-epost-insurance-information-step'>
           
           <div className='ui-epost-insurance-information__basic'>
                
                {/* basic information view */}
                <InsuranceBasicInformationForm
                    values={ get( props, 'basicInformation', {} ) }
                    sectionData={ get( props, 'sections.basicInformation', {} ) }
                    className={ 'ui-epost-insurance-information__basic__form' }
                    onFormSubmit={ props.onBasicInfoUpdate }
                />

                {/* contact information */}
                { isFetchingCommunicationList ? (

                    <MemberAddEditAddresspreloader hideTitle = { true }  />
                    
                ) : (

                    <div className='ui-epost-insurance-information__basic__contact'>

                        <div className='ui-epost-insurance-information__basic__contact__title'>
                            <Icon id={ 'phone' } fill={ '#000'} />

                            <div className='ui-epost-insurance-information__basic__contact__title__value'>
                                { getLabel( get( props, 'sections.contactInformation.title', {} ) ) }
                            </div>
                        </div>
                        <MemberCommunicationSettings
                            { ...get( props, 'sections.contactInformation', {} ) }
                            { ...get( props, 'contactInformation', {} ) }
                            options={ get( props, 'options' ) }
                            actionClassName={ 'ui-epost-insurance-information__basic__action'}
                            onAddEditClick={ props.onAddEditCommunicationDetail }
                            onDefaultClick= { props.onCommunicationDefaultSelection }
                            onDeleteClick={ props.onCommunicationDelete }
                        />
                    </div>
                    
                ) }
            </div>
     
            {/* drug preference */}
          {isDrug && <InsuranceDrugPreferenceForm
                { ...get( props, 'sections.drugPreference', {} ) }
                { ...get( props, 'drugPreference', {} ) }
                options={ get( props, 'options' ) }
                onSwitchDrugPrefernce={ props.onSwitchDrugPrefernce }
            />}

            {/* InsuranceInformation */}
            { eligibleCoverages.length > 0 ? (
                <div className='ui-reactivate-epost-insurance-information-step__coverage'>
                    <label className='ui-reactivate-epost-insurance-information-step__coverage__label' htmlFor='reactivate-eligible-coverage'>Select eligible coverage</label>
                    <select
                        id='reactivate-eligible-coverage'
                        className='ui-reactivate-epost-insurance-information-step__coverage__select'
                        value={ selectedCoverageValue }
                        onChange={ event => props.onCoverageSelection( event.target.value ) }
                    >
                        <option value=''>Select eligible coverage</option>
                        { coverageOptions.map( option => (
                            <option key={ option.value } value={ option.value }>{ get( option, 'title.value', '' ) }</option>
                        ) ) }
                    </select>
                </div>
            ) : null }
            { eligibleCoverages.length === 0 || selectedCoverageValue ? <InsuranceInformation
                { ...get( props, 'sections.insurance', {} ) }
                { ...get( props, 'insurance', {} ) }
                { ...get( props, 'sections.insurance' ) }
                options={ get( props, 'options' ) }
            /> : null }

            {/* address info */}

            { isFetchingAddress ? (

                <MemberAddEditAddresspreloader />

            ) : (
                <MemberAddEditAddress
                    { ...get( props, 'shippingAddress' ) }
                    { ...get( props, 'sections.shippingAddress', {} ) }
                    options={ get( props, 'options' ) }
                    className={ 'ui-epost-insurance-information__basic__shipping' }
                    onAddEditAddressClick={ props.onAddEditAddressClick }
                    onAddressDelete={ props.onAddressDelete }
                    onAddressActivate={ get( props, 'onAddressActivate', {} ) }
                    onAddressInactivate={ get( props, 'onAddressInactivate', {} ) }
                    onDefaultSelection= { get( props, 'onAddressDefaultSelection', {} ) }
                    defaultDescription= { get( props, 'defaultDescription', {} ) }
                    changeConfirmation= { get( props, 'changeConfirmation', {} ) }
                />
            ) }

            {/* address info billing */}
            { !isBilling ? null : isFetchingAddress ? (

                <MemberAddEditAddresspreloader />

            ) : (
               <MemberAddEditBillingAddress
                    { ...get( props, 'billingAddress' ) }
                    { ...get( props, 'sections.billingAddress', {} ) }
                    shippingAddress= { get( props, 'shippingAddress' ) }
                    options={ get( props, 'options' ) }
                    className={ 'ui-epost-insurance-information__basic__billing' }
                    onSwitchSameAsShipping= { props.onSwitchBillingAddressSameAsShipping }
                    onSetAddressDefaultActionBasedOnSection= { props.onSetAddressDefaultActionBasedOnSection }
                    defaultDescription= { get( props, 'defaultDescription', {} ) }
                    changeConfirmation= { get( props, 'changeConfirmation', {} ) }
                    enrollToEpostJourney={ true }
                    sectionName = { 'billingAddress' }
                    enableSelection = { get( props, 'enableSelection', false ) }
                />
            ) }
            

            <div className='ui-epost-insurance-information__actions'>
                { map( props.navActions, action => {
                    return(
                        <Button
                            className={  'ui-epost-insurance-information__actions__action' }
                            { ...action }
                            outline = { 'cancel' === action.name ? true: false }
                            disabled={ 'cancel' !== action.name ? ! props.canMoveForward : false }
                            size='large'
                            key={ action.name }
                            onClick={ () => props.onNavActionClick( { action } ) }
                        />
                    );
                } ) }
            </div>

        </div>
    );
};

// set display name
reactivateEpostInsuranceInformationStepSuccess.displayName = 'reactivateEpostInsuranceInformationStepSuccess';

// set default props
reactivateEpostInsuranceInformationStepSuccess.defaultProps = {};

// prop types
reactivateEpostInsuranceInformationStepSuccess.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { reactivateEpostInsuranceInformationStep as ReactivateEpostInsuranceInformationStep } from 'ui/views/widgets/reactivateEpostInsuranceInformationStep';
 *
 * // render
 * <ReactivateEpostInsuranceInformationStep propName='propValue'/>
 */
export const reactivateEpostInsuranceInformationStep = withNetworkState( epostInsuranceInformationPreloader, reactivateEpostInsuranceInformationStepSuccess );
